// hooks/useCategories.js
import { useCallback, useEffect, useMemo, useState } from 'react';
import { fetchCategories } from '@utils/MarketplaceCategories';

export default function useCategories() {
  const [categories, setCategories] = useState([]);
  const [ready, setReady] = useState(false);

  const load = useCallback(async () => {
    const fetched = await fetchCategories();
    setCategories(fetched);
    setReady(true);
  }, []);

  useEffect(() => {
    load().catch(() => setReady(true));
  }, [load]);

  const catMap = useMemo(
    () => Object.fromEntries(categories.map((c) => [c.id, c])),
    [categories]
  );

  const categoryTree = useMemo(
    () =>
      categories
        .filter((c) => !c.parent)
        .map((p) => ({
          ...p,
          children: categories.filter((c) => c.parent === p.id),
          totalCount: 0,
        })),
    [categories]
  );

  return { categories, catMap, categoryTree, ready, reloadCategories: load };
}
